
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3ol7V", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $74cb85364e25bbd9$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $74cb85364e25bbd9$export$2e2bcd8739ae039 = {
    'people.menu.renotify.flag.description': "Vamos a enviar un recordatorio a todo el mundo por correo electr\xf3nico. Esta acci\xf3n puede tardar hasta un minuto.",
    'people.menu.renotify.flag.description.confluence': "Enviar recordatorio a los compa\xf1eros de equipo",
    'people.menu.renotify.flag.title': 'Enviando recordatorios',
    'people.menu.renotify.flag.title.confluence': "Reenviando correo electr\xf3nico de invitaci\xf3n",
    'people.menu.renotify.menu.description': "{userCount, plural, one {{userCount,number} persona no ha aceptado su invitaci\xf3n de {product}. Comprueba qui\xe9n falta y env\xedale un recordatorio.} other {{userCount,number} personas no han aceptado su invitaci\xf3n de {product}. Comprueba qui\xe9nes faltan y env\xedales un recordatorio.}}",
    'people.menu.renotify.menu.description.confluence': "Algunas personas no han aceptado su invitaci\xf3n de Confluence. Comprueba quienes faltan y env\xedales un recordatorio.",
    'people.menu.renotify.menu.dismiss': 'Descartar',
    'people.menu.renotify.menu.dismiss.confluence': 'Ahora no',
    'people.menu.renotify.menu.remind': 'Recordar a los miembros del equipo',
    'people.menu.renotify.menu.remind.confluence': "Enviar recordatorio a los compa\xf1eros de equipo",
    'people.menu.renotify.menu.title': "\xbfEst\xe1 todo el mundo listo?",
    'people.menu.renotify.modal.copied': 'Enlace copiado',
    'people.menu.renotify.modal.copy': "Copiar enlace de invitaci\xf3n",
    'people.menu.renotify.modal.description': "Podemos enviar un recordatorio por correo electr\xf3nico a los miembros que faltan o puedes compartir el enlace de invitaci\xf3n por tu cuenta.",
    'people.menu.renotify.modal.description.confluence': "Vuelve a enviar el correo electr\xf3nico de invitaci\xf3n o copia y comparte el enlace de invitaci\xf3n.",
    'people.menu.renotify.modal.dismiss': 'Cancelar',
    'people.menu.renotify.modal.resend': 'Enviar recordatorio',
    'people.menu.renotify.modal.resend.confluence': "Reenviar invitaci\xf3n",
    'people.menu.renotify.modal.title': 'Recordar a los miembros que faltan',
    'people.menu.renotify.modal.title.confluence': "Enviar recordatorio a los compa\xf1eros de equipo que faltan",
    'ptc.pm.collaborators.title': 'Tus colaboradores',
    'ptc.pm.error-heading': 'Algo ha ido mal',
    'ptc.pm.error-image-alt-text': 'Un robot roto y varias personas ocupadas intentando arreglarlo.',
    'ptc.pm.error-text': 'Realizamos un seguimiento de estos errores, pero ponte en contacto con nosotros si actualizar no soluciona el problema',
    'ptc.pm.num-members': '{memberCount, plural, one {{memberCount,number} miembro} other {{memberCount,number} miembros}}',
    'ptc.pm.people': 'Personas',
    'ptc.pm.teams': 'Equipos',
    'ptc.pm.view-your-profile': 'Ver tu perfil',
    'ptc.pm.your-teams.title': 'Tus equipos'
};

});


//# sourceMappingURL=es.0e6a65b7.js.map
